import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import LocalStorage from "../../../utilities/localStorage";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  getVendorDetails,
  hsnCategories,
  hsnValues,
  itemValues,
} from "../../vendorRegistration/redux/vendorRegistrationSlice";
import {
  AdditionalDetailsCard,
  concernTypeForJaslok,
  convertToMillions,
  CustomButton,
  CustomFormControl,
  CustomFormSelection,
  DocumentLabels,
  StyledCard,
  StyledOutlineButton,
  VendorCardLabel,
  VendorDisabledFields,
  VRSubTitle,
} from "../../vendorRegistration/components/StepMain";
import VRF_vishakha from "../../../assets/F-PUR-03-VRF-Vishakha.DOCX";
import {
  Box,
  CardContent,
  Checkbox,
  Chip,
  Container,
  FormControl,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { VendorCardTitle } from "../../adminOrders/components/adminOrdersViewContent";
import { UserInfoDiv } from "../../vendorRegistration/components/steps/vendorReg";
import DynamicTextField from "../../../common/sharedComponents/TextField";
import {
  Super,
  VendorCardBlankTitle,
} from "../../vendorRegistration/components/steps/cardTrial";
import GlobalAutocomplete from "../../../common/sharedComponents/AutoComplate";
import { styled as materialStyles } from "@mui/material/styles";
import {
  ArrowRight,
  Clear,
  FileDownload,
  HighlightOff,
  Info,
  Search,
} from "@mui/icons-material";
import { CustomDocumentLink } from "../../../common/sharedComponents/styles/card.style";
import {
  radioStyles,
  radioStyles1,
} from "../../vendorRegistration/components/StepMainEdit";
import Skeleton from "react-loading-skeleton";
import _without from "lodash/without";
import { LocationDiv } from "../../vendorRegistration/components/steps/bankReg";
import { AddBusinessCard } from "../../vendorRegistration/components/steps/bankRegEdit";
import RecipeReviewCard from "../../vendorRegistration/components/steps/cardTrialEdit";
import BankEditComponent from "../../bankDetails/components/bankEditComponent";
import { getBanks } from "../../bankDetails/redux/bankDetailsSlice";
import { LoadingButton } from "@mui/lab";
import { useEdit_vendorMutation } from "../../../utilities/redux-api/vendor/vendorEditByOfficer";
import { message } from "antd";
export const companyConstitution = [
  {
    value: "Association of Persons (AOP)",
    label: "Association of Persons (AOP)",
  },
  { value: "Partnership Firm", label: "Partnership Firm" },
  {
    value: "Individual/One person Company",
    label: "Individual/One person Company",
  },
  { value: "Individual", label: "Individual" },
  { value: "Joint Venture (JV)", label: "Joint Venture (JV)" },
  {
    value: "Limited Liability Partnership (LLP)",
    label: "Limited Liability Partnership (LLP)",
  },
  { value: "Limited", label: "Limited" },
  {
    value: "Limited Company/Listed company",
    label: "Limited Company/Listed company",
  },
  {
    value: "Non banking finance company/ Banking company",
    label: "Non banking finance company/ Banking company",
  },
  { value: "Proprietary Firm", label: "Proprietary Firm" },
  { value: "Private Limited Company", label: "Private Limited Company" },
  { value: "Firm", label: "Firm" },
  { value: "Private Limited", label: "Private Limited" },
  { value: "Co-operative society", label: "Co-operative society" },
  { value: "Foreign Company", label: "Foreign Company" },
  { value: "Hindu Undivided Family", label: "Hindu Undivided Family" },
  { value: "Government Organisation", label: "Government Organisation" },
  { value: "Government Company", label: "Government Company" },
];

export const companyNature = [
  { key: "dta", value: "Domestic Tariff Area (DTA)" },
  { key: "domestic", value: "Indian Company" },
  { key: "foreign company", value: "Foreign Company (Outside India)" },
  { key: "sez", value: "Special Economic Zone (SEZ)" },
  { key: "stpi", value: "Software Technology Parks of India (STPI)" },
];

export const AffirmativeActionCategory = [
  { key: "open", value: "OPEN" },
  { key: "obc", value: "OBC" },
  { key: "sc", value: "SC/ST" },
  { key: "other", value: "OTHERS" },
  { key: "dnd", value: "Don't wish to declare" },
];
export const gstRegistrationType = [
  { key: "regular", value: "Regular" },
  { key: "composition", value: "Composition" },
  { key: "unregistered", value: "Not Applicable" },
];
export const msmeRegistrationType = [
  { key: "Applicable", value: "Applicable" },
  { key: "others", value: "Not Applicable" },
];

const Input = materialStyles("input")({
  display: "none",
});

const getDocUrl = (doc, fallbackUrl) => {
  if (!doc) return null;
  if (doc instanceof File) {
    return URL.createObjectURL(doc);
  }
  if (typeof doc === "string" && doc.startsWith("http")) {
    return doc;
  }
  return doc?.image || doc?.path || fallbackUrl || null;
};

const VendorEditContent = () => {
  const navigate = useNavigate();
  const clientId = LocalStorage.getItem("client")?.id;
  const userdata = JSON.parse(localStorage.getItem("tata_login_user"));
  const { vendor_details, categories, subcategories, itemcategories, loading } =
    useSelector((state) => state.vendorRegistration);
  const [editVendor, { isLoading: editLoader }] = useEdit_vendorMutation();
  const dispatch = useDispatch();
  const vendorId = useParams()?.id;
  const [annualCr, setAnnualCr] = useState(0);
  const [pageLoading, setPageLoading] = useState(true); // tracks only the initial page load
  const [panDoc, setPanDoc] = useState("");
  const [msmeDoc, setmsmeDoc] = useState("");
  const [dealer, setDealer] = useState("");
  const [tin, setTin] = useState("");
  const [iso, setIso] = useState("");
  const [anyDocs, setAnyDocs] = useState([]);
  const [newDocs, setNewDocs] = useState([anyDocs.length]);
  const [checkedType, setCheckedType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchsub, setSearchsub] = useState("");
  const [catdisplay, setCatdisplay] = useState("none");
  const [subcatdisplay, setSubcatdisplay] = useState("none");
  const [itemcatdisplay, setItemcatdisplay] = useState("none");
  const [subCategory, setSubCategory] = useState("");
  const [isLoadingsub, setIsLoadingsub] = useState(false);
  const [searchitem, setSearchitem] = useState("");
  const [isLoadingitem, setIsLoadingitem] = useState(false);
  const [itemcodes, setItemcodes] = useState("");
  const initialSelected = [];
  const [personName, setPersonName] = useState(initialSelected);
  const [expanded, setExpanded] = useState({});
  const [contacts, setContacts] = useState({});
  const [supportingDoc, setSupportingDoc] = useState("");
  const [rtgsDoc, setRtgsDoc] = useState("");
  const [cancelledCheque, setCancelledCheque] = useState("");
  const [bankStatement, setBankStatment] = useState("");
  const [passBook, setPassBook] = useState("");
  // Stores GST File objects per location index (plain React state, NOT RHF — File
  // objects are non-serializable and get stripped by RHF's reset/watch internally)
  const [gstDocFiles, setGstDocFiles] = useState({});

  const {
    handleSubmit,
    formState: { errors },
    watch,
    register,
    reset,
    setValue,
    control,
    unregister,
  } = useForm({
    defaultValues: {
      company_name: vendor_details?.company_name,
      company_email: vendor_details?.company_email,
    },
  });

  const handleclearDoc = (e, index) => {
    let newDocValues = [...anyDocs];
    newDocValues[index] = "";
    setAnyDocs(newDocValues);

    unregister(`supportingDoc ${index}`);
  };
  const handleOnClick = () => {
    let docsCopy = [...newDocs];

    docsCopy.push({
      any_docs: "",
    });

    setNewDocs(docsCopy);
  };
  const handlechangeDoc = (e, index) => {
    let newDocValues = [...anyDocs];
    newDocValues[index] = e.target.files[0];
    setAnyDocs(newDocValues);
    setValue(e.target.name, e.target.files[0]);
  };
  const handleRemove = (e, i) => {
    let uploadeddocs = [...newDocs];
    uploadeddocs.splice(i, 1);
    setNewDocs(uploadeddocs);

    let currentAnyDocs = [...anyDocs];
    currentAnyDocs.splice(i, 1);
    setAnyDocs(currentAnyDocs);
  };

  const handleSave = async (data) => {
    if (!cancelledCheque && !rtgsDoc && !bankStatement) {
      message.error(
        "Please upload at least one of Cancelled Cheque, RTGS, or Bank Statement."
      );
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < newDocs.length; i++) {
      formData.append("supporting_document_image", anyDocs[i]);
    }

    const supportingDocsInfo = anyDocs.map((doc) => {
      if (doc && doc.path) {
        return { name: doc.name, path: doc.path };
      } else if (doc instanceof File) {
        return { name: doc.name, isNew: true };
      } else {
        return null;
      }
    }).filter(Boolean);
    data.supporting_docs_info = supportingDocsInfo;

    data.gst_document_image_index = [];

    if (Object.keys(gstDocFiles).length > 0) {
      Object.entries(gstDocFiles).forEach(([locIndex, file]) => {
        if (file instanceof File) {
          formData.append("gst_document_image", file);
          data.gst_document_image_index.push(Number(locIndex));
        }
      });
    }

    if (data.bussiness_location) {
      data.bussiness_location = data.bussiness_location.map((loc) => {
        const { gst_document_image_file, ...rest } = loc;
        return rest;
      });
    }

    if (contacts && Object.keys(contacts).length > 0) {
      if (data.bussiness_location) {
        data.bussiness_location.forEach((location, index) => {
          if (contacts[index]) {
            location.Contacts = contacts[index];
          }
        });
      }
    }

    formData.append("data", JSON.stringify(data));
    formData.append("pan_image", panDoc);
    formData.append("msme_certificate_image", msmeDoc);
    formData.append("dealer_authorization_image", dealer);
    formData.append("tin_certificate_image", tin);
    formData.append("iso_or_rsdo_or_any_image", iso);
    formData.append("rtgs", rtgsDoc);
    formData.append("supportingDocBank", supportingDoc);
    formData.append("cancelledCheque", cancelledCheque);
    formData.append("bankStatement", bankStatement);
    formData.append("passBook", passBook);

    try {
      await editVendor(formData).unwrap();
      message.success("vendor edit successfully!");
      navigate("/app/vendor");
    } catch (error) {
      if (error?.data) {
        message.error(
          error.data.error || "An error occurred while updating data"
        );
      } else {
        message.error("An unexpected error occurred");
      }
    }
  };
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  // addition information
  const code_filtered = !search
    ? categories
    : categories.filter((categories) =>
      categories.categortDescription
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  const sub_filtered = !searchsub
    ? subcategories
    : subcategories.filter((subcategories) =>
      subcategories.subCategory
        .toLowerCase()
        .includes(searchsub.toLowerCase())
    );
  const item_filtered = !searchitem
    ? itemcategories
    : itemcategories.filter((itemcategories) =>
      itemcategories.item.toLowerCase().includes(searchitem.toLowerCase())
    );
  const getCategories = (payload) => {
    dispatch(hsnCategories(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoading(false);
      }
    });
  };
  const getHSNCodes = (payload) => {
    dispatch(hsnValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingsub(false);
      }
    });
  };
  const getItemsCodes = (payload) => {
    dispatch(itemValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingitem(false);
      }
    });
  };

  const handleadditionalChange = (e, type) => {
    setCheckedType(type);
    // eslint-disable-next-line
    getCategories(type == 2 ? "HSN" : "SAC");
    setIsLoading(true);
    setSearch("");
    setCatdisplay("block");
    setItemcatdisplay("none");
    setSubcatdisplay("none");
  };

  const handlecategoryChange = (e, type) => {
    setSubCategory(type);
    getHSNCodes(type);
    setIsLoadingsub(true);
    setSearchsub("");
    setSubcatdisplay("block");
    setItemcatdisplay("none");
  };

  const handlesubcategoryChange = (e, type) => {
    setItemcodes(type);
    getItemsCodes(type);
    setIsLoadingitem(true);
    setSearchitem("");
    setItemcatdisplay("block");
  };

  const handleCheckChange = (e, type) => {
    const { checked } = e.target;
    let codes = watch("codes") || [];
    if (checked) {
      setValue("codes", [...codes, type]);
      setPersonName([...personName, type]);
    } else {
      const newCodes = codes.filter((c) => c !== type);
      setValue("codes", newCodes);
      setPersonName(personName.filter((p) => p !== type));
    }
  };

  const handleDelete = (chipToDelete) => () => {
    // Get current codes from form
    const currentCodes = watch("codes") || [];
    // Remove the exact chip value from codes array
    const updatedCodes = currentCodes.filter((c) => c !== chipToDelete);
    // Use reset (not setValue) so react-hook-form triggers a re-render
    reset({ ...watch(), codes: updatedCodes });
    // Update selected personName (chips) state
    setPersonName((current) => current.filter((p) => p !== chipToDelete));
  };
  // bussiness details

  const removeDocHandle = (name) => {
    if (name === "pan") {
      setPanDoc("");
      // reset({ ...watch(), pan_doc: { action: "remove" } });
    }
    if (name === "dealerName") {
      setDealer("");
    }
    if (name === "tin_doc") {
      setTin("");
    }
    if (name === "iso_doc") {
      setIso("");
    }
    unregister([name]);
  };
  const addDoc = (e) => {
    const { name, files } = e.target;
    if (name === "pan") {
      setPanDoc(files[0]);
    }
    if (name === "dealerName") {
      setDealer(files[0]);
    }
    if (name === "tin_doc") {
      setTin(files[0]);
    }
    if (name === "iso_doc") {
      setIso(files[0]);
    }
    setValue(name, files[0]);
  };
  const handleExpandClick = (ind) => {
    setExpanded({
      ...expanded,
      [ind]: !expanded[ind],
    });
  };
  const handleSetContacts = (ind, val) => {
    setContacts({
      ...contacts,
      [ind]: val,
    });
  };
  const handleAddLocation = () => {
    let locationsCopy = [...watch("bussiness_location")];

    locationsCopy.push({
      location_gst_id: "",
      location: "",
      phone: "",
      branch_email: "",
      fax_number: "",
      state: "",
      gst_document_image_name: "",
    });
    handleExpandClick(locationsCopy.length - 1);
    setValue("bussiness_location", locationsCopy);
  };
  const handleLocationOnchange = (e, index) => {
    let { name, value } = e.target;

    const locationsCopy = [...(watch("bussiness_location") || [])];

    let extra = {};
    if (name === "gst_document_image_name") {
      if (value instanceof File) {
        // Store the File object in plain React state (NOT in RHF — RHF strips File objects)
        setGstDocFiles((prev) => ({ ...prev, [index]: value }));
        extra = { gst_document_image: null }; // clear old S3 URL
      } else if (!value) {
        // User clicked Remove — clear the stored file for this index
        setGstDocFiles((prev) => {
          const next = { ...prev };
          delete next[index];
          return next;
        });
        extra = { gst_document_image: null };
      }
      value = value instanceof File ? (value.name || "") : (value || "");
    }
    locationsCopy[index] = {
      ...(locationsCopy[index] || {}),
      [name]: value,
      ...extra,
    };

    reset({ ...watch(), bussiness_location: locationsCopy });
  };
  const handleLocationDelete = (index) => {
    let locationsCopy = [...watch("bussiness_location")];
    // eslint-disable-next-line
    locationsCopy = locationsCopy.filter((_, i) => i != index);

    setValue("bussiness_location", locationsCopy);

    // Shift contacts state keys
    const newContacts = {};
    Object.keys(contacts || {}).forEach((key) => {
      const k = parseInt(key);
      if (k < index) {
        newContacts[k] = contacts[k];
      } else if (k > index) {
        newContacts[k - 1] = contacts[k];
      }
    });
    setContacts(newContacts);

    // Shift expanded state keys
    const newExpanded = {};
    Object.keys(expanded || {}).forEach((key) => {
      const k = parseInt(key);
      if (k < index) {
        newExpanded[k] = expanded[k];
      } else if (k > index) {
        newExpanded[k - 1] = expanded[k];
      }
    });
    setExpanded(newExpanded);
  };
  // bank infotmation

  const handleBankInfoChange = (e, index) => {
    let { name, value } = e.target;
    const bankCopy = [...(watch("bank_info") || [])];
    if (name === "is_primary_account") {
      if (value === "false") {
        value = true;
      } else {
        value = false;
      }
    }

    // Deep-copy the bank entry to avoid mutating read-only Redux/RHF state objects
    const currentBank = {
      ...(bankCopy[index] || {}),
      image: { ...(bankCopy[index]?.image || {}) },
      item: { ...(bankCopy[index]?.item || {}) },
    };

    const imageFields = [
      "cancelled_cheque_image_name",
      "rtgs_authorization_letter_image_name",
      "bank_statement_image_name",
      "bank_passbook_copy_with_bank_stamp_image_name",
      "supporting_document_image_name"
    ];

    if (imageFields.includes(name) || name in (currentBank.image || {})) {
      currentBank.image = {
        ...(currentBank.image || {}),
        [name]: value,
      };
    } else {
      currentBank.item = {
        ...(currentBank.item || {}),
        [name]: value,
      };
    }

    bankCopy[index] = currentBank;

    reset({ ...watch(), bank_info: bankCopy });
  };

  useEffect(() => {
    dispatch(getVendorDetails(vendorId)).then((response) => {
      const { success, data } = response.payload;
      if (success) {
        reset({
          vid: data?.id,
          company_name: data?.company_name,
          company_email: data?.company_email,
          legal_name: data?.User?.legal_name,
          permanent_account_number: data?.permanent_account_number,
          company_constitution: {
            key: data?.company_constitution,
            value: data?.company_constitution,
          },
          company_nature: companyNature.find(
            (data1) => data1.key === data?.company_nature
          ),
          affirmative_action_category: AffirmativeActionCategory.find(
            (data1) => data1.key === data?.affirmative_action_category
          ),
          is_domestic: data?.is_domestic,
          registration_type: gstRegistrationType.find(
            (data1) => data1.key === data?.gst_registration_type
          ),
          annual_turnover: data?.annual_turnover,
          tax_identification_number: data?.tax_identification_number,
          msme_register: msmeRegistrationType?.find(
            (data1) => data1?.key === data?.Msme?.msme_type
          ),
          msme_registration_number: data?.Msme?.registration_number,
          msme_doc: data?.Documents[0]?.msme_certificate_image,
          codes: data?.hsn_codes,
          business_interest_areas: data?.business_interest_areas,
          bussiness_location: data?.Locations,
        });
        // Seed personName so handleDelete can track selected chips
        if (Array.isArray(data?.hsn_codes)) {
          setPersonName(data.hsn_codes.filter(Boolean));
        }
        if (response?.payload?.data?.Documents?.[0]?.pan_image_name) {
          setPanDoc({
            name: response?.payload?.data?.Documents?.[0]?.pan_image_name,
            image: response?.payload?.data?.Documents?.[0]?.pan_image,
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]
            ?.supporting_document_image_name
        ) {
          const fileName =
            response?.payload?.data?.Documents?.[0]
              ?.supporting_document_image_name;
          const filePath =
            response?.payload?.data?.Documents?.[0]?.supporting_document_image;
          const concatResource = fileName.map(function (fileName, index) {
            return { name: fileName, path: filePath[index] };
          });
          setAnyDocs(concatResource);
          setNewDocs(concatResource.length > 0 ? concatResource : [0]);
        }

        if (response?.payload?.data?.Documents?.[0]?.msme_certificate_image) {
          setmsmeDoc({
            name: response?.payload?.data?.Documents?.[0]
                ?.msme_certificate_image_name,
            image: response?.payload?.data?.Documents?.[0]
                ?.msme_certificate_image,
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]
            ?.dealer_authorization_image_name
        ) {
          setDealer({
            name: response?.payload?.data?.Documents?.[0]
                ?.dealer_authorization_image_name,
            image: response?.payload?.data?.Documents?.[0]
                ?.dealer_authorization_image,
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]?.tin_certificate_image_name
        ) {
          setTin({
            name: response?.payload?.data?.Documents?.[0]
                ?.tin_certificate_image_name,
            image: response?.payload?.data?.Documents?.[0]
                ?.tin_certificate_image,
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]?.iso_or_rsdo_or_any_image_name
        ) {
          setIso({
            name: response?.payload?.data?.Documents?.[0]
                ?.iso_or_rsdo_or_any_image_name,
            image: response?.payload?.data?.Documents?.[0]
                ?.iso_or_rsdo_or_any_image,
          });
        }

        dispatch(getBanks({ user_id: data?.UserId, vendor_id: data?.id })).then(
          (response) => {
            const { success: done, data: data1 } = response.payload;

            if (done) {
              reset({ ...watch(), bank_info: data1 || [] });
              const Bank_Documents = data1[0]?.image;

              if (Bank_Documents && Bank_Documents?.cancelled_cheque_image) {
                setCancelledCheque({
                  name: Bank_Documents?.cancelled_cheque_image_name,
                  image: Bank_Documents?.cancelled_cheque_image,
                });
              }

              if (Bank_Documents && Bank_Documents?.bank_statement_image) {
                setBankStatment({
                  name: Bank_Documents?.bank_statement_image_name,
                  image: Bank_Documents?.bank_statement_image,
                });
              }
              if (
                Bank_Documents &&
                Bank_Documents?.rtgs_authorization_letter_image
              ) {
                setRtgsDoc({
                  name: Bank_Documents?.rtgs_authorization_letter_image_name,
                  image: Bank_Documents?.rtgs_authorization_letter_image,
                });
              }
              if (
                Bank_Documents &&
                Bank_Documents?.bank_passbook_copy_with_bank_stamp_image
              ) {
                setPassBook({
                  name: Bank_Documents?.bank_passbook_copy_with_bank_stamp_image_name,
                  image:
                    Bank_Documents?.bank_passbook_copy_with_bank_stamp_image,
                });
              }
              if (Bank_Documents && Bank_Documents?.supporting_document_image) {
                setSupportingDoc({
                  name: Bank_Documents?.supporting_document_image_name,
                  image: Bank_Documents?.supporting_document_image,
                });
              }
            }
          }
        );
        setAnnualCr(convertToMillions(data?.annual_turnover));
      }
      setPageLoading(false);
    }).catch(() => {
      setPageLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {

  //   if (
  //     watch("bank_info")?.[0] &&
  //     watch("bank_info")?.[0]?.Bank_Documents?.length &&
  //     onETime
  //   ) {

  // setOneTime(false);
  // }, [watch("bank_info")?.[0]?.Bank_Documents]);
  return pageLoading || vendor_details?.[0] === "loading" ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <div>
      <form onSubmit={handleSubmit(handleSave)} encType="multipart/form-data">
        {/*statutory_information  */}
        <StyledCard>
          <CardContent>
            <Container fixed>
              <Grid>
                <VendorCardTitle>Statutory information</VendorCardTitle>
                <UserInfoDiv>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                      <VendorCardLabel>Company name</VendorCardLabel>
                      <VendorDisabledFields>
                        {watch("company_name")}
                      </VendorDisabledFields>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <VendorCardLabel>Legal name</VendorCardLabel>
                      <VendorDisabledFields>
                        {watch("legal_name") !== null
                          ? watch("legal_name")
                          : "Not Applicable"}
                      </VendorDisabledFields>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <VendorCardLabel>
                        Permanent account number (PAN)
                      </VendorCardLabel>

                      <VendorDisabledFields>
                        {typeof watch("permanent_account_number") !==
                          undefined && watch("legal_name") !== null
                          ? `${watch("permanent_account_number")}`
                          : `International`}
                      </VendorDisabledFields>
                    </Grid>
                  </Grid>
                </UserInfoDiv>
              </Grid>
              <br />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>
                    Company email <Super>*</Super>
                  </VendorCardLabel>
                  <DynamicTextField
                    name="company_email"
                    placeholder="Enter Company Email"
                    register={register}
                    control={control}
                    errors={errors}
                    watch={watch}
                    reset={reset}
                    validationRules={{
                      required: "Please Enter Company email",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>
                    Company constitution<Super>*</Super>
                  </VendorCardLabel>
                  <GlobalAutocomplete
                    control={control}
                    name={"company_constitution"}
                    options={
                      clientId === 5
                        ? concernTypeForJaslok.map((el) => {
                          return {
                            key: el.concernType,
                            value: el.concernType,
                          };
                        })
                        : companyConstitution.map((el) => {
                          return {
                            key: el.value,
                            value: el.label,
                          };
                        })
                    }
                    // value={{
                    //   key: watch("company_constitution"),
                    //   value: watch("company_constitution"),
                    // }}
                    placeholder={`Select Company constitution`}
                    rules={{
                      required: `Company constitution is required`,
                    }}
                    isMultiple={false}
                    onSelect={() => { }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>
                    Company nature<Super>*</Super>
                  </VendorCardLabel>
                  <GlobalAutocomplete
                    control={control}
                    name={"company_nature"}
                    options={companyNature.map((el) => {
                      return {
                        key: el.key,
                        value: el.value,
                      };
                    })}
                    // value={{
                    //   key: watch("company_nature"),
                    //   value: companyNature.find(
                    //     (data) => data.value === watch("company_nature")
                    //   )?.label,
                    // }}
                    placeholder={`Select Company nature`}
                    rules={{
                      required: `Company nature is required`,
                    }}
                    isMultiple={false}
                    onSelect={() => { }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>Affirmative action category</VendorCardLabel>
                  <GlobalAutocomplete
                    control={control}
                    name={"affirmative_action_category"}
                    options={AffirmativeActionCategory.map((el) => {
                      return {
                        key: el.key,
                        value: el.value,
                      };
                    })}
                    // value={{
                    //   key: watch("company_nature"),
                    //   value: companyNature.find(
                    //     (data) => data.value === watch("company_nature")
                    //   )?.label,
                    // }}
                    placeholder={`Select Affirmative action category`}
                    isMultiple={false}
                    onSelect={() => { }}
                  />
                </Grid>
                {watch("is_domestic") && (
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Registration type (GST)<Super>*</Super>
                    </VendorCardLabel>
                    <GlobalAutocomplete
                      control={control}
                      name={"registration_type"}
                      options={gstRegistrationType
                        .filter(
                          (el) =>
                            el.key !== "unregistered" ||
                            vendor_details?.gst_registration_type === "unregistered"
                        )
                        .map((el) => {
                          return {
                            key: el.key,
                            value: el.value,
                          };
                        })}
                      // value={{
                      //   key: watch("company_nature"),
                      //   value: companyNature.find(
                      //     (data) => data.value === watch("company_nature")
                      //   )?.label,
                      // }}
                      placeholder={`Select Registration type (GST)`}
                      rules={{
                        required: `Registration type (GST) is required`,
                      }}
                      isMultiple={false}
                      onSelect={() => { }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>
                    Tax Identification number (TIN)
                  </VendorCardLabel>
                  <DynamicTextField
                    name="tax_identification_number"
                    placeholder="Do not enter GSTIN here"
                    register={register}
                    control={control}
                    errors={errors}
                    watch={watch}
                    reset={reset}
                    validationRules={{
                      required: false,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>
                    Annual turnover (in Million)
                  </VendorCardLabel>
                  <DynamicTextField
                    name="annual_turnover"
                    placeholder="Enter annual turnover"
                    register={register}
                    errors={errors}
                    watch={watch}
                    reset={reset}
                    control={control}
                    validationRules={{
                      pattern: {
                        value: /^-?\d*(\.\d{1,2})?$/,
                        message: "Invalid number format",
                      },
                    }}
                    // onChange={(e) => {
                    //   setValue(e.target.name, e.target.value);
                    //   setAnnualCr(convertToMillions(e.target.value));
                    // }}
                    handleChange={(name, value) => {
                      setAnnualCr(convertToMillions(value));
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <VendorCardLabel>Annual turnover (in Crore)</VendorCardLabel>
                  <VendorDisabledFields>{annualCr}</VendorDisabledFields>
                </Grid>
              </Grid>
            </Container>
          </CardContent>
        </StyledCard>
        {/*  msme_information*/}
        {watch("is_domestic") && (
          <StyledCard>
            <CardContent>
              <Container fixed>
                <VendorCardTitle>MSME information</VendorCardTitle>
                <VRSubTitle>For tax purposes</VRSubTitle>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4}>
                    <VendorCardLabel>
                      Are you MSME registered? <Super>*</Super>
                    </VendorCardLabel>
                    <GlobalAutocomplete
                      control={control}
                      name={"msme_register"}
                      options={msmeRegistrationType.map((el) => {
                        return {
                          key: el?.key,
                          value: el?.value,
                        };
                      })}
                      placeholder={`Select MSME category`}
                      rules={{
                        required: `Please select MSME category`,
                      }}
                      isMultiple={false}
                      onSelect={(selectedOption) => {
                        if (selectedOption.key === "others") {
                          unregister("msme_registration_number");
                          setmsmeDoc("");
                        }
                      }}
                    />
                  </Grid>

                  {watch("msme_register")?.key !== "others" && (
                    <>
                      <Grid item xs={12} md={4}>
                        <VendorCardLabel>
                          MSME registration number <Super>*</Super>{" "}
                        </VendorCardLabel>
                        <DynamicTextField
                          name="msme_registration_number"
                          placeholder="Enter MSME registration number"
                          register={register}
                          control={control}
                          errors={errors}
                          watch={watch}
                          reset={reset}
                          validationRules={{
                            validate: (value) => {
                              if (watch("msme_register")?.key !== "others") {
                                return value?.trim()
                                  ? true
                                  : "Please Enter MSME registration number";
                              }
                              return true; // No validation if "Not Applicable" is selected
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Grid item xs={6}>
                          <FormControl
                            variant="standard"
                            style={{ width: "100%" }}
                            error={Boolean(errors?.msme)}
                          >
                            {msmeDoc !== "" ? (
                              <>
                                <span
                                  style={{
                                    color: "#4945FF",
                                    fontSize: "13px",
                                    fontFamily: "var(--font-family-reg)",
                                  }}
                                >
                                  {(() => {
                                    const msmeUrl = getDocUrl(msmeDoc, vendor_details?.Documents?.[0]?.msme_certificate_image);
                                    return (
                                      <Chip
                                        style={{
                                          width: "150px",
                                          color: "#4945FF",
                                          margin: "5px",
                                          borderRadius: "5px",
                                          border: "1px solid #D9D8FF",
                                          background: "#F0F0FF",
                                        }}
                                        label={msmeDoc?.name || (msmeDoc instanceof File ? msmeDoc.name : msmeDoc)}
                                        value={msmeDoc?.name}
                                        name="chips"
                                        {...(msmeUrl
                                          ? {
                                              component: "a",
                                              clickable: true,
                                              href: msmeUrl,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            }
                                          : {})}
                                      />
                                    );
                                  })()}
                                  <HighlightOff
                                    sx={{
                                      color: "#4945FF",
                                      paddingBottom: "2px",
                                    }}
                                    fontSize="medium"
                                    onClick={(e) => setmsmeDoc("")}
                                  />
                                </span>
                              </>
                            ) : (
                              <label htmlFor="msme">
                                <Input
                                  {...register("msme", {
                                    required: "Please upload vendor form copy",
                                  })}
                                  accept="*"
                                  id="msme"
                                  name="msme"
                                  onChange={(e) =>
                                    setmsmeDoc(e.target.files[0])
                                  }
                                  type="file"
                                />
                                <StyledOutlineButton
                                  variant="outlined"
                                  component="span"
                                >
                                  Upload
                                </StyledOutlineButton>
                                <span>{msmeDoc.name}</span>
                              </label>
                            )}
                            {msmeDoc === "" ? (
                              <FormHelperText>
                                {errors.msme?.message}
                              </FormHelperText>
                            ) : (
                              ""
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Container>
            </CardContent>
          </StyledCard>
        )}
        {/* documents */}
        <StyledCard>
          <CardContent>
            <Container fixed>
              <VendorCardTitle style={{ marginBottom: "3px" }}>
                Documents
              </VendorCardTitle>
              <VRSubTitle>
                <span>
                  <Info color="primary" />
                </span>
                {"\u00A0"}
                {"\u00A0"}
                TDS may be deducted at higher rates in case of incorrect or
                missing PAN information as per IT rules
              </VRSubTitle>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                {watch("is_domestic") && (
                  <>
                    {/* pan */}
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <span
                          variant="outlined"
                          component="span"
                          style={{ width: "50%" }}
                        >
                          <DocumentLabels>
                            Upload PAN copy<Super>*</Super>
                          </DocumentLabels>
                        </span>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl
                          variant="standard"
                          style={{ width: "100%" }}
                          error={Boolean(errors?.pan)}
                        >
                          {panDoc !== "" ? (
                            <>
                              <span
                                style={{
                                  color: "#4945FF",
                                  fontSize: "13px",
                                  fontFamily: "var(--font-family-reg)",
                                }}
                              >
                                {(() => {
                                  const panUrl = getDocUrl(panDoc, vendor_details?.Documents?.[0]?.pan_image);
                                  return (
                                    <Chip
                                      style={{
                                        width: "150px",
                                        color: "#4945FF",
                                        margin: "5px",
                                        borderRadius: "5px",
                                        border: "1px solid #D9D8FF",
                                        background: "#F0F0FF",
                                      }}
                                      label={panDoc?.name || (panDoc instanceof File ? panDoc.name : panDoc)}
                                      value={panDoc?.name}
                                      name="chips"
                                      {...(panUrl
                                        ? {
                                            component: "a",
                                            clickable: true,
                                            href: panUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          }
                                        : {})}
                                    />
                                  );
                                })()}
                                <HighlightOff
                                  sx={{ color: "#4945FF", paddingBottom: "2px" }}
                                  fontSize="medium"
                                  onClick={(e) => removeDocHandle("pan")}
                                />
                              </span>
                            </>
                          ) : (
                            <label htmlFor="pan">
                              <Input
                                {...register("pan", {
                                  required: "Please upload PAN copy",
                                })}
                                accept="*"
                                id="pan"
                                onChange={addDoc}
                                type="file"
                              />
                              <StyledOutlineButton
                                variant="outlined"
                                component="span"
                              >
                                Upload
                              </StyledOutlineButton>
                            </label>
                          )}
                          {panDoc === "" ? (
                            <FormHelperText>{errors.pan?.message}</FormHelperText>
                          ) : (
                            ""
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>

                    {/* dealer ship form */}
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}>
                        <span
                          variant="outlined"
                          component="span"
                          style={{ width: "50%" }}
                        >
                          <DocumentLabels>
                            {clientId === 3 ? "VAD" : "Vendor information form"}
                            {clientId === 3 ||
                              (clientId === 2 && <Super>*</Super>)}
                          </DocumentLabels>
                          {clientId === 2 && (
                            <CustomDocumentLink
                              style={{ fontSize: "0.8rem" }}
                              href={VRF_vishakha}
                            >
                              <FileDownload fontSize="small" color="primary" />
                              {"\u00A0"} Download Form
                            </CustomDocumentLink>
                          )}
                        </span>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl
                          variant="standard"
                          style={{ width: "100%" }}
                          error={Boolean(errors?.dealerName)}
                        >
                          {dealer !== "" ? (
                            <>
                              <span
                                style={{
                                  color: "#4945FF",
                                  fontSize: "13px",
                                  fontFamily: "var(--font-family-reg)",
                                }}
                              >
                                {(() => {
                                  const dealerUrl = getDocUrl(dealer, vendor_details?.Documents?.[0]?.dealer_authorization_image);
                                  return (
                                    <Chip
                                      style={{
                                        width: "150px",
                                        color: "#4945FF",
                                        margin: "5px",
                                        borderRadius: "5px",
                                        border: "1px solid #D9D8FF",
                                        background: "#F0F0FF",
                                      }}
                                      label={dealer?.name || (dealer instanceof File ? dealer.name : dealer)}
                                      value={dealer?.name}
                                      name="chips"
                                      {...(dealerUrl
                                        ? {
                                            component: "a",
                                            clickable: true,
                                            href: dealerUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          }
                                        : {})}
                                    />
                                  );
                                })()}
                                <HighlightOff
                                  sx={{ color: "#4945FF", paddingBottom: "2px" }}
                                  fontSize="medium"
                                  onClick={(e) => removeDocHandle("dealerName")}
                                />
                              </span>
                            </>
                          ) : (
                            <label htmlFor="dealerName">
                              <Input
                                {...register("dealerName", {
                                  required:
                                    clientId === 1 || clientId === 5
                                      ? false
                                      : "Please upload vendor form copy",
                                })}
                                accept="*"
                                id="dealerName"
                                name="dealerName"
                                onChange={addDoc}
                                type="file"
                              />

                              <StyledOutlineButton
                                variant="outlined"
                                component="span"
                              >
                                Upload
                              </StyledOutlineButton>
                              <span>{dealer.name}</span>
                            </label>
                          )}
                          {dealer === "" ? (
                            <FormHelperText>
                              {errors.dealerName?.message}
                            </FormHelperText>
                          ) : (
                            ""
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>

                    {/* TIN certificate */}
                    {clientId !== 2 && (
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <span
                            variant="outlined"
                            component="span"
                            style={{ width: "50%" }}
                          >
                            <DocumentLabels>
                              Upload TIN certificate
                            </DocumentLabels>
                          </span>
                        </Grid>
                        <Grid item xs={6}>
                          {tin !== "" ? (
                            <>
                              <span
                                style={{
                                  color: "#4945FF",
                                  fontSize: "13px",
                                  fontFamily: "var(--font-family-reg)",
                                }}
                              >
                                {(() => {
                                  const tinUrl = getDocUrl(tin, vendor_details?.Documents?.[0]?.tin_certificate_image);
                                  return (
                                    <Chip
                                      style={{
                                        width: "150px",
                                        color: "#4945FF",
                                        margin: "5px",
                                        borderRadius: "5px",
                                        border: "1px solid #D9D8FF",
                                        background: "#F0F0FF",
                                      }}
                                      label={tin?.name || (tin instanceof File ? tin.name : tin)}
                                      value={tin?.name}
                                      name="chips"
                                      {...(tinUrl
                                        ? {
                                            component: "a",
                                            clickable: true,
                                            href: tinUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          }
                                        : {})}
                                    />
                                  );
                                })()}
                                <HighlightOff
                                  sx={{
                                    color: "#4945FF",
                                    paddingBottom: "2px",
                                  }}
                                  fontSize="medium"
                                  onClick={(e) => removeDocHandle("tin_doc")}
                                />
                              </span>
                            </>
                          ) : (
                            <label htmlFor="tin_doc">
                              <Input
                                accept="*"
                                id="tin_doc"
                                name="tin_doc"
                                onChange={addDoc}
                                type="file"
                              />
                              <StyledOutlineButton
                                variant="outlined"
                                component="span"
                              >
                                Upload
                              </StyledOutlineButton>
                              <span>{tin.name}</span>
                            </label>
                          )}
                        </Grid>
                      </Grid>
                    )}

                    {/* ISO certificate */}
                    {clientId !== 2 && (
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <span
                            variant="outlined"
                            component="span"
                            style={{ width: "50%" }}
                          >
                            <DocumentLabels>
                              Upload ISO, RSDO and any additional certificate
                            </DocumentLabels>
                          </span>
                        </Grid>
                        <Grid item xs={6}>
                          {iso !== "" ? (
                            <>
                              <span
                                style={{
                                  color: "#4945FF",
                                  fontSize: "13px",
                                  fontFamily: "var(--font-family-reg)",
                                }}
                              >
                                {(() => {
                                  const isoUrl = getDocUrl(iso, vendor_details?.Documents?.[0]?.iso_or_rsdo_or_any_image);
                                  return (
                                    <Chip
                                      style={{
                                        width: "150px",
                                        color: "#4945FF",
                                        margin: "5px",
                                        borderRadius: "5px",
                                        border: "1px solid #D9D8FF",
                                        background: "#F0F0FF",
                                      }}
                                      label={iso?.name || (iso instanceof File ? iso.name : iso)}
                                      value={iso?.name}
                                      name="chips"
                                      {...(isoUrl
                                        ? {
                                            component: "a",
                                            clickable: true,
                                            href: isoUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          }
                                        : {})}
                                    />
                                  );
                                })()}
                                <HighlightOff
                                  sx={{
                                    color: "#4945FF",
                                    paddingBottom: "2px",
                                  }}
                                  fontSize="medium"
                                  onClick={(e) => removeDocHandle("iso_doc")}
                                />
                              </span>
                            </>
                          ) : (
                            <label htmlFor="iso_doc">
                              <Input
                                accept="*"
                                id="iso_doc"
                                name="iso_doc"
                                onChange={addDoc}
                                type="file"
                              />
                              <StyledOutlineButton
                                variant="outlined"
                                component="span"
                              >
                                Upload
                              </StyledOutlineButton>
                              <span>{iso.name}</span>
                            </label>
                          )}
                        </Grid>
                      </Grid>
                    )}

                    {/* supporting documents */}
                    {newDocs.map((item, index) => (
                      <Grid
                        container
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        key={index}
                        style={{ marginTop: "10px" }}
                      >
                        <Grid item xs={6}>
                          <span
                            variant="outlined"
                            component="span"
                            style={{ width: "50%" }}
                          >
                            <DocumentLabels style={{ marginTop: "10px" }}>
                              {index === 0 ? "Upload Any Documents" : ""}
                            </DocumentLabels>
                          </span>
                        </Grid>
                        {anyDocs[index] && anyDocs[index] !== "" ? (
                          <>
                            <Grid item xs={6}>
                              <FormControl
                                variant="standard"
                                style={{ width: "100%" }}
                              >
                                <span
                                  style={{
                                    color: "#4945FF",
                                    fontSize: "13px",
                                    fontFamily: "var(--font-family-reg)",
                                  }}
                                >
                                  {(() => {
                                    const anyDocUrl = getDocUrl(anyDocs[index]);
                                    return (
                                      <Chip
                                        style={{
                                          width: "150px",
                                          color: "#4945FF",
                                          margin: "5px",
                                          borderRadius: "5px",
                                          border: "1px solid #D9D8FF",
                                          background: "#F0F0FF",
                                        }}
                                        label={anyDocs[index]?.name || (anyDocs[index] instanceof File ? anyDocs[index].name : anyDocs[index])}
                                        value={anyDocs[index]?.name}
                                        name="chips"
                                        {...(anyDocUrl
                                          ? {
                                              component: "a",
                                              clickable: true,
                                              href: anyDocUrl,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            }
                                          : {})}
                                      />
                                    );
                                  })()}
                                  <HighlightOff
                                    sx={{
                                      color: "#4945FF",
                                      paddingBottom: "2px",
                                    }}
                                    fontSize="medium"
                                    onClick={(e) => handleclearDoc(e, index)}
                                  />
                                </span>
                              </FormControl>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid item xs={3}>
                              <FormControl
                                variant="standard"
                                style={{ width: "100%" }}
                              >
                                <label>
                                  <Input
                                    accept="*"
                                    id={`anyDocs${index}`}
                                    name={`supportingDoc ${index}`}
                                    onChange={(e) =>
                                      handlechangeDoc(e, index)
                                    }
                                    type="file"
                                  />
                                  <StyledOutlineButton
                                    variant="outlined"
                                    component="span"
                                  >
                                    Upload
                                  </StyledOutlineButton>
                                </label>
                              </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                              {index > 0 ? (
                                <CustomButton
                                  className="invoiceErrbutn"
                                  color="error"
                                  variant="outlined"
                                  size="small"
                                  onClick={(e) => handleRemove(e, index)}
                                  style={{ marginTop: "10px " }}
                                >
                                  Remove
                                </CustomButton>
                              ) : (
                                ""
                              )}
                            </Grid>
                          </>
                        )}
                      </Grid>
                    ))}

                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      style={{ marginTop: "10px" }}
                    >
                      <Grid item xs={6}></Grid>
                      <Grid item xs={6}>
                        <CustomButton
                          size="small"
                          color="primary"
                          variant="outlined"
                          onClick={handleOnClick}
                          className="invoiceErrbutn"
                        >
                          Add Document
                        </CustomButton>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </Container>
          </CardContent>
        </StyledCard>
        {/* additional info like hsn/sac */}
        <StyledCard>
          <CardContent>
            <Container fixed>
              <VendorCardTitle>Additional information</VendorCardTitle>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={6} md={9}>
                  <VRSubTitle>
                    Areas of business interest. Select all that apply and wait
                    for the HSN/SAC code to appear below
                  </VRSubTitle>
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <VRSubTitle style={{ textAlign: "right" }}>
                    <a
                      rel="noopener noreferrer"
                      href={`${userdata?.domain_url}/api/hsn_codes`}
                      style={{
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        color: "#4059e5",
                      }}
                      target="_blank"
                    >
                      Download Codesheet
                    </a>
                  </VRSubTitle>
                </Grid>
              </Grid>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item md={3} xs={12}>
                  <AdditionalDetailsCard>
                    <CardContent style={{ overflow: "auto", height: "272px" }}>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                      // style={{ marginTop: "36px" }}
                      >
                        <Grid
                          style={
                            checkedType === "2" ? radioStyles.selectRadio : null
                          }
                        >
                          <CustomFormSelection
                            value="2"
                            control={<Radio style={{ visibility: "hidden" }} />}
                            label="Goods"
                            style={{
                              textAlign: "-23px",
                            }}
                            onChange={(e) => handleadditionalChange(e, "2")}
                            className="goods"
                          />

                          {checkedType === "2" ? (
                            <ArrowRight
                              style={{
                                textAlign: "center",
                                float: "right",
                                marginTop: "7px",
                                marginLeft: "-32px",
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid
                          style={
                            checkedType === "1" ? radioStyles.selectRadio : null
                          }
                        >
                          <CustomFormSelection
                            value="1"
                            control={<Radio style={{ visibility: "hidden" }} />}
                            label="Services"
                            /*  style={{ textAlign: "-25px" }} */
                            onChange={(e) => handleadditionalChange(e, "1")}
                            className="goods"
                          />
                          <span
                            style={{
                              textAlign: "center",
                              float: "right",
                              marginTop: "7px",
                              marginLeft: "-32px",
                            }}
                          >
                            {checkedType === "1" ? <ArrowRight /> : ""}
                          </span>
                        </Grid>
                      </RadioGroup>
                    </CardContent>
                  </AdditionalDetailsCard>
                </Grid>
                {isLoading ? (
                  <Grid item md={3} xs={12}>
                    <AdditionalDetailsCard>
                      <CardContent
                        style={{ overflow: "auto", height: "272px" }}
                      >
                        <Skeleton count={7} />
                      </CardContent>
                    </AdditionalDetailsCard>
                  </Grid>
                ) : (
                  code_filtered && (
                    <Grid item md={3} xs={12} style={{ display: catdisplay }}>
                      <AdditionalDetailsCard>
                        <div
                          style={{
                            height: "50px",
                            backgroundColor: " #F7F9FC",
                          }}
                        >
                          <TextField
                            id="Search"
                            InputProps={{
                              endAdornment: (
                                <IconButton>
                                  <Search fontSize="small" />
                                </IconButton>
                              ),
                            }}
                            className="search_for_add_info"
                            variant="standard"
                            onChange={(e) => handleSearchChange(e)}
                            placeholder="Search by description"
                          />
                        </div>
                        <CardContent
                          style={{
                            paddingTop: "5px",
                            overflow: "auto",
                            height: "222px",
                          }}
                        >
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                          >
                            {code_filtered.length ? (
                              code_filtered.map((item, index) => (
                                <Grid
                                  key={index}
                                  style={
                                    subCategory === `${item.category}`
                                      ? radioStyles1.selectRadio
                                      : null
                                  }
                                >
                                  <Tooltip
                                    title={item.categortDescription}
                                    placement="right"
                                  >
                                    <CustomFormControl
                                      style={{
                                        fontSize: "12px",
                                      }}
                                      label={item.categortDescription}
                                      value={item.category}
                                      control={
                                        <Radio
                                          style={{ visibility: "hidden" }}
                                        />
                                      }
                                      onChange={(e) =>
                                        handlecategoryChange(
                                          e,
                                          `${item.category}`
                                        )
                                      }
                                      className="goods1"
                                    />
                                  </Tooltip>
                                </Grid>
                              ))
                            ) : (
                              <VendorCardLabel>
                                <br />
                                <Info
                                  sx={{
                                    fill: "grey",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                                {"There are no categeories to display"}
                              </VendorCardLabel>
                            )}
                          </RadioGroup>
                        </CardContent>
                      </AdditionalDetailsCard>
                    </Grid>
                  )
                )}
                {isLoadingsub ? (
                  <Grid item md={3} xs={12}>
                    <AdditionalDetailsCard>
                      <CardContent
                        style={{ overflow: "auto", height: "272px" }}
                      >
                        <Skeleton count={7} />
                      </CardContent>
                    </AdditionalDetailsCard>
                  </Grid>
                ) : (
                  sub_filtered && (
                    <Grid
                      item
                      md={3}
                      xs={12}
                      style={{ display: subcatdisplay }}
                    >
                      <AdditionalDetailsCard>
                        <div
                          style={{
                            height: "50px",
                            backgroundColor: " #F7F9FC",
                          }}
                        >
                          <TextField
                            id="Search"
                            InputProps={{
                              endAdornment: (
                                <IconButton>
                                  <Search fontSize="small" />
                                </IconButton>
                              ),
                            }}
                            className="search_for_add_info"
                            variant="standard"
                            onChange={(e) => setSearchsub(e.target.value)}
                            style={{ fontSize: "12px !important" }}
                            placeholder="Search by code"
                          />
                        </div>
                        <CardContent
                          style={{
                            paddingTop: "5px",
                            overflow: "auto",
                            height: "222px",
                          }}
                        >
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                          >
                            {sub_filtered.length ? (
                              sub_filtered.map((item, index) => (
                                <Grid
                                  key={index}
                                  style={
                                    itemcodes === `${item.subCategory}`
                                      ? radioStyles1.selectRadio
                                      : null
                                  }
                                >
                                  <Tooltip
                                    title={item.subCategoryDescription}
                                    placement="right"
                                  >
                                    <CustomFormControl
                                      style={{
                                        fontSize: "12px",
                                      }}
                                      label={
                                        item.subCategory +
                                        " - " +
                                        item.subCategoryDescription
                                      }
                                      value={item.subCategory}
                                      control={
                                        <Radio
                                          style={{ visibility: "hidden" }}
                                        />
                                      }
                                      onChange={(e) =>
                                        handlesubcategoryChange(
                                          e,
                                          `${item.subCategory}`
                                        )
                                      }
                                      className="goods1"
                                    />
                                  </Tooltip>
                                </Grid>
                              ))
                            ) : (
                              <VendorCardLabel>
                                <br />
                                <Info
                                  sx={{
                                    fill: "grey",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                                {"There are no categeories to display"}
                              </VendorCardLabel>
                            )}
                          </RadioGroup>
                        </CardContent>
                      </AdditionalDetailsCard>
                    </Grid>
                  )
                )}
                {isLoadingitem ? (
                  <Grid item md={3} xs={12}>
                    <AdditionalDetailsCard>
                      <CardContent
                        style={{ overflow: "auto", height: "272px" }}
                      >
                        <Skeleton count={7} />
                      </CardContent>
                    </AdditionalDetailsCard>
                  </Grid>
                ) : (
                  item_filtered && (
                    <Grid
                      item
                      md={3}
                      xs={12}
                      style={{ display: itemcatdisplay }}
                    >
                      <AdditionalDetailsCard>
                        <div
                          style={{
                            height: "50px",
                            backgroundColor: " #F7F9FC",
                          }}
                        >
                          <TextField
                            id="Search"
                            InputProps={{
                              endAdornment: (
                                <IconButton>
                                  <Search fontSize="small" />
                                </IconButton>
                              ),
                            }}
                            className="search_for_add_info"
                            variant="standard"
                            onChange={(e) => setSearchitem(e.target.value)}
                            style={{ fontSize: "12px !important" }}
                            placeholder="Search by code"
                          />
                        </div>
                        <CardContent
                          style={{
                            paddingTop: "5px",
                            overflow: "auto",
                            height: "222px",
                          }}
                        >
                          {item_filtered.length ? (
                            item_filtered.map((item, index) => (
                              <FormGroup
                                key={item.id}
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                              >
                                <Grid key={item.id}>
                                  <Tooltip
                                    title={item.itemDescription}
                                    placement="bottom"
                                  >
                                    <CustomFormControl
                                      multiple
                                      key={item.id}
                                      style={{ fontSize: "12px" }}
                                      value={item.item}
                                      control={
                                        <Checkbox
                                          sx={{
                                            color: "lightgray",
                                            "&.Mui-checked": {
                                              color: "#4059e5",
                                            },
                                          }}
                                          checked={personName.includes(
                                            `${item.item}`
                                          )}
                                        />
                                      }
                                      label={
                                        item.item + " - " + item.itemDescription
                                      }
                                      className="itemName"
                                      onChange={(e) =>
                                        handleCheckChange(e, `${item.item}`)
                                      }
                                    />
                                  </Tooltip>
                                </Grid>
                              </FormGroup>
                            ))
                          ) : (
                            <VendorCardLabel>
                              <br />
                              <Info
                                sx={{
                                  fill: "grey",
                                  height: "18px",
                                  width: "18px",
                                }}
                              />
                              {"There are no sub categeories to display"}
                            </VendorCardLabel>
                          )}
                        </CardContent>
                      </AdditionalDetailsCard>
                    </Grid>
                  )
                )}
              </Grid>
              <br />
              <VendorCardTitle style={{ paddingBottom: "0px" }}>
                Selected HSN/SAC Codes
              </VendorCardTitle>
              <FormControl>
                <Stack direction="row" spacing={4}>
                  <Grid item xs={2}>
                    <VendorCardBlankTitle
                      style={{ marginTop: "0", marginBottom: "10px" }}
                    >
                      {watch("codes")?.length && "No codes selected."}
                    </VendorCardBlankTitle>

                    {watch("codes")?.map((item, index) =>
                      item !== "null" ? (
                        <Chip
                          key={index}
                          style={{
                            color: "#4945FF",
                            margin: "0 5px 10px 0 ",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={item}
                          value={item}
                          name="chips"
                          onDelete={handleDelete(item)}
                          deleteIcon={
                            <Clear sx={{ height: "18px", width: "18px" }} />
                          }
                        />
                      ) : (
                        ""
                      )
                    )}
                  </Grid>
                </Stack>
              </FormControl>
              <Grid>
                <VendorCardLabel>Additional business areas</VendorCardLabel>{" "}
                <DynamicTextField
                  name="business_interest_areas"
                  placeholder="Enter interest areas"
                  register={register}
                  control={control}
                  errors={errors}
                  watch={watch}
                  reset={reset}
                  validationRules={{
                    required: false,
                  }}
                />
              </Grid>
            </Container>
          </CardContent>
        </StyledCard>

        {/* bussiness details */}
        {watch("bussiness_location")?.map((location_item, index) => (
          <RecipeReviewCard
            key={index}
            l_index={index}
            location_item={{
              ...location_item,
              user_id: vendor_details?.UserId,
            }}
            register={register}
            errors={errors}
            expanded={expanded[index] || true}
            handleExpandClick={handleExpandClick}
            // contacts={contacts?.[0] || {}}
            contacts={
              contacts?.[index] ?? watch("bussiness_location")?.[index]?.Contacts
            }
            setContacts={(value) => handleSetContacts(index, value)}
            onChange={handleLocationOnchange}
            onDelete={handleLocationDelete}
            registerType={watch("registration_type")?.key}
            clientId={clientId}
            is_domestic={watch("is_domestic")}
            setChangeLocationData={setValue}
          />
        ))}
        {(clientId !== 5 && clientId !== 2) ||
          (!watch("bussiness_location")?.length && (
            <AddBusinessCard>
              <CardContent>
                <Grid onClick={handleAddLocation}>
                  <LocationDiv>+ Add business location</LocationDiv>
                </Grid>
              </CardContent>
            </AddBusinessCard>
          ))}
        {/* bank information */}
        <StyledCard>
          {watch("bank_info")?.length ? (
            watch("bank_info").map((bank, index) => {
              return (
                <BankEditComponent
                  register={register}
                  bank_item={bank?.item || {}}
                  clientId={clientId}
                  errors={errors}
                  is_domestic={watch("is_domestic")}
                  l_index={index}
                  onChange={handleBankInfoChange}
                  supportingDoc={supportingDoc}
                  setSupportingDoc={setSupportingDoc}
                  rtgsDoc={rtgsDoc}
                  setRtgsDoc={setRtgsDoc}
                  cancelledCheque={cancelledCheque}
                  setCancelledCheque={setCancelledCheque}
                  bankStatement={bankStatement}
                  setBankStatment={setBankStatment}
                  passBook={passBook}
                  setPassBook={setPassBook}
                />
              );
            })
          ) : (
            <BankEditComponent
              register={register}
              bank_item={watch("bank_info")?.[0] || {}}
              clientId={clientId}
              errors={errors}
              is_domestic={watch("is_domestic")}
              l_index={0}
              onChange={handleBankInfoChange}
              supportingDoc={supportingDoc}
              setSupportingDoc={setSupportingDoc}
              rtgsDoc={rtgsDoc}
              setRtgsDoc={setRtgsDoc}
              cancelledCheque={cancelledCheque}
              setCancelledCheque={setCancelledCheque}
              bankStatement={bankStatement}
              setBankStatment={setBankStatment}
              passBook={passBook}
              setPassBook={setPassBook}
            />
          )}
        </StyledCard>
        <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
          <Box sx={{ flex: "1 1 auto" }} />
          <LoadingButton
            sx={{
              textTransform: "none",
              background: "var(--button-color)",
              width: "200px",
              height: "40px",
            }}
            color="success"
            variant="contained"
            disabled={editLoader}
            type="submit"
            loading={editLoader}
            loadingPosition="start"
          >
            Update
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
};

export default VendorEditContent;
